module.exports = __webpack_public_path__ + "components/discount-pages/roadsurfer/static/roadsurfer-2560-e3d637967145613753555c31907e6304.jpg";